export const removeLanguageCode = (url) => {
  const secondSlashIndex = url?.indexOf('/', url?.indexOf('/') + 1);
  const pathAfterSecondSlash = url?.substring(secondSlashIndex);
  return pathAfterSecondSlash;
};
